function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './ListingServicesHeader.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, canUseDOM, getDictionaryItem } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Filters from '../Listing/Filters';
import AutocompleteField from '../Listing/AutocompleteField';
import getListing from '../../utils/getListing';
import { getAlgoliaTagsList, convertQueryParamsToFacets } from '../Listing';
import { qsToObject } from '../../utils/querystring';
import { useLocation } from 'react-router-dom';
const ListingServicesHeader = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const currentLang = get(sitecoreContext, 'language');
  const dictionary = get(fields, 'data.dictionary');
  const day = getDictionaryItem(dictionary, 'Day') || 'day';
  const days = getDictionaryItem(dictionary, 'Days') || 'days';
  const showLabel = getDictionaryItem(dictionary, 'Show') || 'show';
  const resultsLabel = getDictionaryItem(dictionary, 'Results') || 'results';
  const clearAllLabel = getDictionaryItem(dictionary, 'ClearAll') || 'ClearAll';
  const Cancel = getDictionaryItem(dictionary, 'Cancel') || 'Cancel';
  const FiltersCopy = getDictionaryItem(dictionary, 'Filters') || 'Filters';
  const Or = getDictionaryItem(dictionary, 'Or') || 'Or';
  const SearchPlaceholder = getDictionaryItem(dictionary, 'search by keyword') || 'search by keyword';
  const SelectService = getDictionaryItem(dictionary, 'selected services') || 'select services';
  const ServiceFilter = getDictionaryItem(dictionary, 'services filter description') || 'services filter description';
  const filterValue = get(fields, 'data.listingConfiguration.filters.values') || [];
  const filterData = get(fields, 'data.listingConfiguration.filters', {});
  const resultDropdownSetting = {
    "name": "Service Tags",
    "title": {
      "jss": {
        "value": ServiceFilter
      }
    },
    "fieldNameItem": {
      "item": {
        "fieldName": {
          "value": ServiceFilter
        }
      }
    },
    "fieldTypeItem": {
      "item": {
        "fieldType": {
          "value": "Dropdown result"
        }
      }
    }
  };
  const filterDataConcat = _objectSpread(_objectSpread({}, filterData), {}, {
    values: [...filterData.values, resultDropdownSetting]
  });
  const location = useLocation();
  const queryParams = qsToObject(location.search);
  const [resetFilter, setResetFilter] = React.useState(false);
  const [facets, setFacets] = React.useState();
  const [defaultFacets, setdefaultFacets] = React.useState([]);
  const [nbHits, setNbHits] = React.useState(0);
  const [hits, setHits] = React.useState([]);
  const [queryHits, setQueryHits] = React.useState([]);
  const [page, setpage] = React.useState(0);
  const indexes = get(params, 'SearchIndex');
  const typeArray = get(fields, 'data.listingConfiguration.contentType.types') || [];
  let facetFilters = convertQueryParamsToFacets(queryParams, true, filterData);
  const [firstRendering, setFirstRendering] = React.useState(false);
  const [setFilters, applySetFilters] = React.useState(false);
  const [result, setResult] = React.useState();
  const [currentTypes, applycurrentTypes] = React.useState([]);
  const pageSize = get(fields, 'data.listingConfiguration.pageSize.jss.value') || 10;
  const defaultInfoTitle = get(fields, 'data.item.pageTitle.jss.value');
  const helperText = get(fields, 'data.item.pageIntro.jss.value');
  const smallTitle = get(fields, 'data.item.smallTitle.jss.value');
  const [themeName, setThemeName] = React.useState('theme-1');
  React.useEffect(() => {
    let facetNames = [];
    let tag = 'tags:';
    if (canUseDOM) {
      const hash = window.location.hash;
      const hashvalue = hash.split('#tag=');
      if (hashvalue[1]) {
        tag = 'tags:' + decodeURI(hashvalue[1]);
      }
    }
    let types = typeArray.map(type => {
      let value = type && type.value;
      // if (value === 'Single Day Itinerary') value = 'Single Day Itinerary Page';
      // if (value === 'Multiple Days Itinerary') value = 'Multiple Days Itinerary Page';

      return `type:${value}`;
    });
    applycurrentTypes(types);
    if (filterData) {
      facetNames = filterData.values.map(filter => {
        return get(filter, 'fieldNameItem.item.fieldName.value');
      });
    }
    let filters;
    if (queryParams.datesRange) {
      filters = queryParams.datesRange.split('+').join(' ');
    } else {
      let filterValues = getAlgoliaTagsList(filterData);
      if (filterValues.indexOf('datesRange') > -1) {
        filters = `datesRange.to > ${Date.parse(new Date()) / 1000}`;
      }
      if (~filterValues.indexOf('universityPrograms.programs.anualFee') && queryParams['universityPrograms.programs.anualFee']) {
        filters = `${queryParams['universityPrograms.programs.anualFee']}`.split('+').join(' ');
        filters = filters.replace('anualFee', 'annualFee').replace('anualFee', 'annualFee');
      }
    }
    if (queryParams.valid) {
      filters = queryParams.valid.split('+').join(' ');
    }
    const isLoadedFeatureItem = firstRendering && types.length == 1 && types[0] == "type:Event";
    const itemFilters = {
      filters,
      facets: [...facetNames],
      facetFilters: [[...types], ...facetFilters, [tag]],
      hitsPerPage: pageSize,
      page: page
    };
    // if(facetFilters.length !== 0){
    //  lastQuery = facetFilters[facetFilters.length -1][0].split(':')[0]
    // // facetFilters && facetFilters[0] && facetFilters[0][0].split(':')[0]
    // }

    getListing(indexes, itemFilters, algoliaSettings).then(response => {
      setFacets(response.facets);
      setResult(response);
      applySetFilters(false);
      setNbHits(response.nbHits);
      if (response.hits.length) {
        setHits(hits.concat(response.hits[0].featured && isLoadedFeatureItem && response.nbPages > 1 ? response.hits.splice(0, response.hits.length - 1) : response.hits));
      }
      setTimeout(function () {
        if (canUseDOM) {
          window.onscroll = () => {};
        }
      }, 100);
      setFirstRendering(false);
    });
  }, [resetFilter, setFilters, page]);
  const getValues = querySearch => {
    getListing(indexes, {}, algoliaSettings, {
      query: querySearch,
      hitsPerPage: pageSize
    }).then(response => {
      setQueryHits(response.hits);
    });
  };
  React.useEffect(() => {
    let facetNames = [];
    let tag = 'tags:';
    if (canUseDOM) {
      const hash = window.location.hash;
      const hashvalue = hash.split('#tag=');
      if (hashvalue[1]) {
        tag = 'tags:' + decodeURI(hashvalue[1]);
      }
    }
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setThemeName('theme-27');
    }
    let types = typeArray.map(type => {
      let value = type && type.value;
      // value
      // if (value === 'Single Day Itinerary') value = 'Single Day Itinerary Page';
      // if (value === 'Multiple Days Itinerary') value = 'Multiple Days Itinerary Page';

      return `type:${value == 'Service' ? '' : value}`;
    });
    if (filterData) {
      facetNames = filterData.values.map(filter => {
        return get(filter, 'fieldNameItem.item.fieldName.value');
      });
    }
    const itemFilters = {
      facets: [...facetNames],
      facetFilters: [[...types], [tag]],
      hitsPerPage: pageSize,
      page: page
    };
    getListing(indexes, itemFilters, algoliaSettings).then(response => {
      setdefaultFacets(response.facets);
      setQueryHits(response.hits);
    });
  }, []);
  const setFilter = filtersRecived => {
    getValues(filtersRecived);
  };
  const setListingFilter = filtersRecived => {
    setpage(0);
    setHits([]);
    applySetFilters(true);
    setdefaultFacets(result && result.facets);
  };
  const resetFilterCallback = () => {
    setFacets(undefined);
    setResult(undefined);
    // setNbHits(0);
    // setNbHits2(0);
    setHits([]);
    setpage(0);
    setResetFilter(true);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "services-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: `services-header__holder ${themeName}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-topbot"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-9 offset-md-1"
  }, !!defaultInfoTitle && /*#__PURE__*/React.createElement("h1", {
    className: "h2 hs__title"
  }, defaultInfoTitle), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(AutocompleteField, {
    setFilter: setFilter,
    facetsName: 'Test',
    clearAlllFilters: false,
    hits: queryHits,
    placeholder: SearchPlaceholder
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "services-header__subText"
  }, /*#__PURE__*/React.createElement("span", null, Or)))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("p", {
    className: "services-header__filterDesc"
  }, SelectService), filterValue && filterValue.length >= 1 && /*#__PURE__*/React.createElement(Filters, {
    params: params,
    fields: filterDataConcat,
    facets: facets,
    defaultFacets: defaultFacets,
    showLabel: showLabel,
    resultsLabel: resultsLabel,
    nbHits: nbHits,
    clearAllLabel: clearAllLabel,
    setListingFilter: setListingFilter,
    resetFilterCallback: resetFilterCallback,
    day: day,
    days: days,
    Cancel: Cancel,
    FiltersCopy: FiltersCopy,
    isTagPage: false,
    lang: currentLang,
    hits: hits,
    dictionary: dictionary,
    firstQuery: '',
    analytics: {},
    imageDictionary: {},
    fullWidth: true,
    showClearAll: false,
    apllyFiltersOnChange: true,
    resetAllFiltersCallback: () => {}
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "services-header__description"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-9 offset-md-1"
  }, !!smallTitle && /*#__PURE__*/React.createElement("h2", {
    className: "h3 hs__title"
  }, smallTitle), /*#__PURE__*/React.createElement("p", {
    className: "desk__desc"
  }, helperText))))));
};
const commonStyles = "cy008i5";
const rtlStyles = "r1fmwvrq";
const ltrStyles = "l13a3spn";
const commonoFocusEvent = "c56y12";
const ColorsLogic = "c2i1zhz";
const globalStyles = "g1nwmec2";
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    minHeight: true,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${globalStyles} ${commonoFocusEvent} ${ColorsLogic}`,
    removePaddingMobile: true
  }, children);
};
export default ListingServicesHeader;